export default __webpack_public_path__ + "src/assets/trezor.e31ddaa373e6f45a0d07b6f641280ff0.svg";